import { SUPPORTED_LOCALES } from './locales';

// Only pages with complete translations and prerendered HTML have language URLs.
export const LOCALIZED_PAGE_PATHS = ['/customizer', '/custom-design'];

export const getLocalizedRoute = (path) => {
  const pathname = String(path).split(/[?#]/)[0].replace(/\/$/, '');
  for (const { code } of SUPPORTED_LOCALES) {
    for (const basePath of LOCALIZED_PAGE_PATHS) {
      const localizedPath = code === 'en' ? basePath : `/${code.toLowerCase()}${basePath}`;
      if (pathname === localizedPath) return { basePath, locale: code };
    }
  }
  return null;
};

export const getLocalizedPath = (path, locale) => {
  const route = getLocalizedRoute(path);
  if (!route || !SUPPORTED_LOCALES.some(({ code }) => code === locale)) return path;
  const suffix = String(path).match(/[?#].*$/)?.[0] || '';
  return `${locale === 'en' ? '' : `/${locale.toLowerCase()}`}${route.basePath}${suffix}`;
};

export const getLanguageAlternates = (path) => {
  const route = getLocalizedRoute(path);
  return route ? SUPPORTED_LOCALES.map(({ code }) => ({
    locale: code,
    path: getLocalizedPath(route.basePath, code),
  })) : [];
};
